export default class CategoryObject {
  static initCategory() {
    return {
      UniqueId: "",
      InterestId: "",
      Name: "",
      AccountId: "",
      MainCategoryInterestId: "",
      ForProduct: true,
      ForUser: true,
      ForEvent: true,
      ForLocation: true,
      Ranking: null,
      InSearchEngine: true,
      DefaultSelectedInSearchEngine: false,
      Picture: "",
      PictureUrl: "",
      SubCategories: []
    };
  }
}
